import { useBlockFriend } from "@/entities/friend/api/mutations"
import { useCurrentUserId } from "@/entities/user"
import * as m from "@/paraglide/messages"
import StopSign from "@/shared/assets/coolicons/Warning/Stop_Sign.svg?react"
import { showSystemPopup } from "@/shared/lib/platform"

interface BlockFriendButtonProps {
	friendId: number
	onBlock?: (friendId: number) => void
}

export function BlockFriendButton({
	friendId,
	onBlock,
}: BlockFriendButtonProps) {
	const userId = useCurrentUserId()
	const blockFriend = useBlockFriend()

	const handleBlock = async () => {
		const buttonId = await showSystemPopup({
			title: m.friendProfileBlockTitle(),
			message: m.friendProfileBlockMessage(),
			buttons: [
				{ id: "cancel", text: m.commonBtnCancel() },
				{
					id: "ok",
					text: m.friendProfileBlockConfirm(),
					type: "destructive",
				},
			],
		})

		if (buttonId !== "ok") return

		blockFriend.mutate(
			{
				userId,
				friendId,
			},
			{
				onSuccess: () => {
					onBlock?.(friendId)
				},
			},
		)
	}

	return (
		<button
			type="button"
			onClick={handleBlock}
			disabled={blockFriend.isPending}
			className="relative isolate flex h-11.75 w-full flex-col items-start justify-center gap-1.75 bg-white px-3 py-0 disabled:opacity-50"
		>
			{/* Divider */}
			<div className="absolute inset-x-[4.46%] top-0 h-px bg-[#d9dce5]" />

			<div className="flex w-full flex-row items-center justify-start gap-2.5">
				<StopSign className="size-6 shrink-0 text-[#282a33]" />
				<span className="text-center text-base leading-5 font-medium text-[#282a33]">
					{blockFriend.isPending
						? m.friendProfileBlockLoading()
						: m.friendProfileBlockConfirm()}
				</span>
			</div>
		</button>
	)
}
